/* @flow */
import React from 'react';

import ActivitiesClassView from 'groups/components/ActivitiesClassView.jsx';
import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import type { InitialValues as ComposerInitialValues } from 'payments/components/ActivityAnnouncementTeacherComposer.jsx';
import { mountModal } from 'lib/modal';

class ActivitiesCreateView extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  componentDidMount() {
    mountModal(<ActivityCreateDialogContainer createParams={this.getCreateParams()} />, this);
  }

  getCreateParams(): ComposerInitialValues {
    const query = this.context.router.location.query;
    return {
      title: query.title,
      location: query.location,
      date: query.start_at && new Date(query.start_at),
      amount: query.amount_per_person && parseInt(query.amount_per_person, 10),
      type: query.event_type,
      hasChildren: query.has_children ? query.has_children === 'true' : null,
      disableReplies: query.disable_replies ? query.disable_replies === 'true' : null,
      message: query.welcome_msg_body,
    };
  }

  render() {
    return (
      <ActivitiesClassView />
    );
  }

}

export default ActivitiesCreateView;



// WEBPACK FOOTER //
// ./src/groups/components/ActivitiesCreateView.jsx